import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRenewalRequestDetails,updateRequestStatus } from "services/redux/contractRenewal/action";
import RenewalRequestDetails from "./renewalRequestDetails";

const mapStateToProps = (state) => ({
  requestDetails: state.contractRenewalReducer.requestDetails,
  requestStatus: state.contractRenewalReducer.requestStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getRenewalRequestDetails,
        updateRequestStatus
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RenewalRequestDetails);
